import {GenericService, ResultType} from '@/shared/xhttp';
import {Achat, Pile} from '@/models';
import {DateHelper} from "@/shared/utils";

export class PileService extends GenericService<Pile> {
}